"use strict"

const conditional = (
  data: any,
  findRules: any,
  field: any,
  required_field: any,
  route_id: any
) => {
  if (
    data[required_field] &&
    data[route_id] &&
    (data[field] === null || data[field] === "" || data[field] === undefined)
  ) {
    throw new Error(`Campo ${findRules.name} é obrigatório`)
  }
}

const validator = (data: any, field: string, args: any) => {
  const [required_field, route_id] = args
  console.log(data)
  const fields = JSON.parse(localStorage.getItem("fields") as any)
  data = data.original
  const findRules = fields.data.find((el: any) => el.slug == field)

  if (!findRules) return true
  if (data.operational && findRules.operational_visible) {
    conditional(data, findRules, field, required_field, route_id)
  } else if (
    data.detached &&
    JSON.parse(data.detached) &&
    findRules.detached_visible
  ) {
    conditional(data, findRules, field, required_field, route_id)
  } else if (findRules.visible) {
    conditional(data, findRules, field, required_field, route_id)
  }
  return true
}

export const requiredIfCustom = {
  async: false,
  validate: validator,
}
